import { IAgentOfferListingsClient, IGetResponse } from 'interfaceAdapter/gatewaySchemas/IAgentOfferListingsClient';
import { API_LOCATION_URL } from 'infrastructure/config';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/agent/offer/listings`;

export class AgentOfferListingsClient implements IAgentOfferListingsClient {
    async get(input: any): Promise<IGetResponse> {
        const { token } = input;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-A': token,
        };
        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }

        const params = new URLSearchParams();

        if (input.limit) {
            params.append('limit', input.limit.toString());
        }

        if (input.offset) {
            params.append('offset', input.offset.toString());
        }

        const queryString = params.toString();

        try {
            const response = await fetch(`${PATH}?${queryString}`, {
                method,
                headers,
            });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
